module.exports = __webpack_public_path__ + "img/generic-quickstart.2b50be2.png";